import { Container } from "@afas-doe-maar/ui/Container";
import { Logo } from "@afas-doe-maar/ui/Logo";
import { cn } from "@afas-doe-maar/ui/utils";
import { forwardRef } from "react";
import type { VoteRouteProps } from "./VoteScreen";

export const VoteEnded = forwardRef<HTMLDivElement, VoteRouteProps>(function VoteEnded(
  { transitionState },
  ref,
) {
  return (
    <Container
      ref={ref}
      className={cn(
        "pointer-events-none flex scale-200 flex-col items-center justify-center gap-4 text-center opacity-0 transition-[scale,opacity] duration-500",
        {
          entering: "scale-100 opacity-100",
          entered: "pointer-events-auto scale-100 opacity-100",
          exiting: "scale-200 opacity-0",
          exited: "scale-200 opacity-0",
          unmounted: "",
        }[transitionState],
      )}
    >
      <Logo className="w-[80%]" />
      <p className="text-2xl font-bold">Bedankt voor je deelname!</p>
    </Container>
  );
});
